<div class="auth-layout flex flex-col lg:flex-row h-screen bg-gray-100">
  <bey-auth-header-branding
    [title]="(routeData$ | async)?.['title']"
    [customLayout]="(routeData$ |async)?.['customLayout']"></bey-auth-header-branding>
  <router-outlet></router-outlet>
  <bey-auth-aside-branding class="w-[56.25%] h-full hidden lg:block"></bey-auth-aside-branding>
</div>
